import { cn } from '@commenda/utils';
import React from 'react';

interface FormHeaderProps {
  heading: string;
  subheading?: string;
  className?: string;
}

const FormHeader: React.FC<FormHeaderProps> = ({
  heading,
  subheading,
  className,
}) => {
  return (
    <div className={cn('border-b pb-3 px-4 w-full', className)}>
      <h3 className="txt-extra-large-bold">{heading}</h3>
      <p className="text-sm font-normal mt-1 text-neutral-2">
        {subheading ?? ''}
      </p>
    </div>
  );
};

export default FormHeader;
